import { useFormikContext } from 'formik';
import { Dispatch, FC, SetStateAction, useEffect } from 'react';
import _ from 'lodash';

interface Props {
    setHasChanges: (hasChanged) => void
    setTabErrorFlags?: Dispatch<SetStateAction<boolean[]>>
    selectedTab?: number
}
/**
 * A sneaky way to monitor for form changes and change state.
 * @param param0
 */
const AutoStateUpdate: FC<Props> = ({ setHasChanges, setTabErrorFlags, selectedTab = 0 }) => {
    const { errors, values, initialValues, submitForm } = useFormikContext();

    useEffect(() => {
        try {
            if (setTabErrorFlags) {
                const hasError = Object.keys(errors as any).length > 0;
                setTabErrorFlags((errorArray: boolean[]) => {
                    const updatedArray = [...errorArray];
                    updatedArray[selectedTab] = hasError;
                    return updatedArray;
                });
            }
        } catch (error) {
            console.error(error);
        }
    }, [errors]);

    useEffect(() => {
        const jsonValues = JSON.stringify(values, null, 2);
        const jsonInitialValues = JSON.stringify(initialValues, null, 2);

        // Initial values have been changed. I.e. user input. Flag as having changes.
        if (!_.isEqual(jsonValues, jsonInitialValues)) {
            setHasChanges(true);
        }
    }, [values, submitForm]);
    return null;
};

export default AutoStateUpdate
